import React, { useContext, useState, useEffect, useRef } from "react"
import Context from "../utils/Context"
import { cancelActions, cancelLast, releaseLifter } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faCog, faWindowClose, faStopCircle } from '@fortawesome/free-solid-svg-icons'
import ShowMessage from "../components/ShowMessage"
import PauseOptions from "../components/PauseOptions"
import ModalSendMission from "../components/ModalSendMission"
import api from "../api/api"
import ListOrders from "./ListOrders"

export default function Orders() {
  const context = useContext(Context)

  const [orders, setOrders] = useState()
  const isMounted = useRef(true)
  const listHeaders = ["mission", "robot", "start", "state", "action"]
  const [timerBlocked, setTimerBlocked] = useState(false)
  const [timerCount, setTimerCount] = useState(0)
  const role = (~context.user?.roles.indexOf('admin')) ? true : false
  const [cancelled, setCancelled] = useState(null)
  const refreshRate = 5000
  const [trigger, setTrigger] = useState([])
  const [activeModalSendMission, setActiveModalSendMission] = useState(false)
  const [device, setDevice] = useState(null)
  const [operations, setOperations] = useState([]);
  const [showOperationSelector, setShowOperationSelector] = useState(false);
  const [selectedOperationId, setSelectedOperationId] = useState("");

  const cancelledSet = cancel => setCancelled(cancel)

  useEffect(() => {
    if (timerBlocked) {
      var timer = { count: 3 }
      var start = setInterval(function (timer) {
        if (timer.count == 0) {
          clearInterval(start)
          setTimerBlocked(false)
        }
        //console.log("+++", timer.count)
        setTimerCount(timer.count)
        timer.count--
      }, 1000, timer)
    }
  }, [timerBlocked])

  useEffect(() => {
    if (isMounted.current)
      api
        .fetchOrders({ dtCompleted: { $exists: false }, cancelled: false })
        .then((res) => {
          res && isMounted.current && setOrders(res.data)
        })
        .catch((e) => console.log(e))

    api
      .fetchTriggers({ processed: false, device: { $ne: "Stop-Missions" } })
      .then((res) => {
        setTrigger(res.data)
      })
      .catch((e) => console.log(e))
  }, [cancelled])

  useEffect(() => {
    const refresher = setInterval(() => {
      if (isMounted.current)
        api
          .fetchOrders({ dtCompleted: { $exists: false }, cancelled: false })
          .then((res) => {
            res && isMounted.current && setOrders(res.data)
          })
          .catch((e) => console.log(e))

      api
        .fetchTriggers({ processed: false, device: { $ne: "Stop-Missions" } })
        .then((res) => {
          setTrigger(res.data)
        })
        .catch((e) => console.log(e))
    }, refreshRate)

    return () => {
      if (refresher) clearInterval(refresher)
    }
  }, [])

  const cancelTriggers = (id) => {
    api
      .cancelTriggers(id)
      .then((res) => {
        setCancelled(!cancelled)
        console.log("RES", res)
      })
      .catch((e) => console.log(e))
  }

  const selectOrder = (orderId) => {
    if (!orderId) {
      return false
    }
  }

  // execute a trigger
  const execTrigger = (device) => {
    // check if the trigger starts with "P-", because it is a rule to send a mission to drop
    if (device.startsWith("P-") || device.startsWith("Pick")) {
      setDevice(device)
      context.actions.setSignatureCounter(context.signatureCounter + 1)
      setActiveModalSendMission(true)
    } else {

      api.sendTrigger({ device: device, processed: false, uname: context.username, dtInsert: new Date() }).then(res => {
        context.actions.setMessage({ message: "Started.", type: "success" })
        setTimerBlocked(true)
      })
        .catch((error) => {
          context.actions.setMessage({ message: "Erro.", type: "error" })
          context.actions.setErrorMessage(error.response?.status)
        })
    }
  }

  const stopMission = async () => {
    setTimerBlocked(true)
    if (context.selectedRobot.ROS === 'ROS2') {
      cancelActions({ stopall: true }, context.selectedRobot.ROS)
    } else {
      cancelActions({ stopAll: true }, context.selectedRobot.ROS)
    }
    releaseLifter({ data: 64 })

    context.actions.setCurrentMission(null)

    try {
      await api.cancelAllOrders()

      trigger.forEach(element => {
        cancelTriggers(element._id)
      })

      execTrigger("Stop-Missions")

    } catch (error) {
      context.actions.setMessage({ message: "Error to Start in server", type: "error" })
    }

    context.actions.setMessage({ message: "Mission Stoped!", type: "success" })
  }

  const importTriggers = () => {
    api.getOperations({}).then(res => {
      setOperations(res.data);
      setShowOperationSelector(true)
    });
  };

  const handleOperationSelect = (e) => {
    setSelectedOperationId(e.target.value)
  };

  const confirmImportTriggers = () => {
    if (!selectedOperationId) return
    api.fetchOperation(selectedOperationId).then(res => {
      const newTriggers = res.data[0].triggers.map(device => ({
        name: device.device,
        mission: device.mission
      }))
      context.actions.setAvailableTriggers(newTriggers)
      setShowOperationSelector(false)
      setSelectedOperationId("")
    }).catch(error => {
      console.error("Error fetching devices:", error)
    })
  }

  const startPauseHold = () => {
    console.log("Start pause")
    if (context.selectedRobot.ROS === 'ROS2') cancelLast({ stophold: true }, context.selectedRobot.ROS)
    else cancelLast({ stopHold: true }, context.selectedRobot.ROS)
    context.actions.setModalState({ ...context.modalState, activePause: !context.modalState.activePause })
  }

  const stopPauseHold = () => {
    console.log("Stop pause")
    if (context.selectedRobot.ROS === 'ROS2') cancelLast({ stophold: true }, context.selectedRobot.ROS)
    else cancelLast({ stopHold: true }, context.selectedRobot.ROS)
  }

  return (
    <div>
      {/* Modal/Combo para selecionar operação antes de importar triggers */}
      {showOperationSelector && (
        <div className="modal is-active">
          <div className="modal-background" onClick={() => setShowOperationSelector(false)}></div>

          <div className="modal-card" style={{ maxWidth: 400 }}>
            <header className="modal-card-head">
              <p className="modal-card-title">Select Operation</p>

              <button className="delete" aria-label="close" onClick={() => setShowOperationSelector(false)}></button>
            </header>

            <section className="modal-card-body">
              <div className="field">
                <label className="label">Operation</label>

                <div className="control">
                  <div className="select is-fullwidth">
                    <select value={selectedOperationId} onChange={handleOperationSelect}>
                      <option value="" disabled>Select an operation...</option>
                      {operations.map(op => (
                        <option key={op._id} value={op._id}>{op.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </section>

            <footer className="modal-card-foot">
              <button className="button is-success" onClick={confirmImportTriggers} disabled={!selectedOperationId}>
                Import
              </button>

              <button className="button" onClick={() => setShowOperationSelector(false)}>
                Cancel
              </button>
            </footer>
          </div>
        </div>
      )}

      {activeModalSendMission && <ModalSendMission missionName={device} setActiveModalSendMission={(value) => setActiveModalSendMission(value)} />}

      <div className="columns">
        <div className="column">
          {role &&
            <button
              onClick={() => context.actions.setModalState({ ...context.modalState, trigger: true })}
              className="button is-success mb-5 mr-3"
              styles={{ marginRight: "1rem" }}
              disabled={context.modalState.activePause}
            >
              <FontAwesomeIcon icon={faPlus} className="is-small mr-1" />
              Manage
            </button>
          }

          <button
            onClick={importTriggers}
            className="button is-link mb-5 mr-3"
          >
            <FontAwesomeIcon icon={faPlus} className="is-small mr-1" />
            Import Missions
          </button>

          <button
            onClick={startPauseHold}
            className="button is-danger is-light mb-5 mr-3"
            disabled={context.modalState.activePause}
          >
            <FontAwesomeIcon icon={faCog} className="is-small mr-1" />
            {!context.modalState.activePause ? "Settings" : "Paused"}
          </button>

          <button
            disabled={timerBlocked || context.currentTask === 'release-charger' || context.currentTask === 'undock'}
            onClick={stopMission}
            className="button is-danger mb-5 mr-3"
          >
            <FontAwesomeIcon icon={faStopCircle} className="is-small mr-1" />
            Cancel All
          </button>
        </div>
      </div>

      <div className="columns">
        <div className="column">
          {context.availableTriggers?.map((e, i) => (
            <button key={i} disabled={timerBlocked} className="button is-outlined is-link mr-2 mb-2" onClick={() => execTrigger(e.name)}>
              {(context.orderStatus && e.name === context.missionName) &&
                <FontAwesomeIcon icon={faCog} className="fas fa-pulse" />
              }
              {e.name + " "}
              {timerCount === 0 ? "" : "(" + timerCount + ")"}
            </button>
          ))}
        </div>
      </div>

      {context.modalState.activePause &&
        <PauseOptions stopPauseHold={stopPauseHold} />
      }

      <ShowMessage />

      {orders &&
        <div className="box" style={{ "borderRadius": "15px", "textAlign": "center" }}>
          <div className="column is-12">
            <ListOrders data={orders} handler={selectOrder} headers={listHeaders} cancelled={cancelledSet} cancelledValue={cancelled} />
          </div>
        </div>
      }

      <div className="columns">
        <div className="column">
          {trigger.map((e, i) => (
            <button key={i} className="button is-danger is-light mb-5 mr-3" onClick={() => cancelTriggers(e._id)}>
              {(i + 1) + " : " + e.device}
              <FontAwesomeIcon icon={faWindowClose} className="is-small ml-2" />
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}